export const GymDashboardDetailsHeaderRoutes = {
  visits: 0,
  activity: 1,
  inquiries: 2
};

export type GymDashboardDetailsHeaderTabNames = keyof typeof GymDashboardDetailsHeaderRoutes;
